module.exports = {
	"title": {
		"artist": "Hören Sie {artistName} auf Qobuz",
		"album": "Hören Sie {albumName} von {artistName} auf Qobuz",
		"track": "Hören Sie {trackName} von {artistName} auf Qobuz",
		"playlist": "Hören Sie die Playlist {playlistName} von {ownerName} auf Qobuz",
		"story": "Lesen Sie diesen Artikel auf Qobuz"
	},
	"buttons": {
		"listen": "Auf Qobuz hören",
		"buy": "Kaufen",
		"share": "Teilen",
		"download": "Kostenlos testen",
		"readmore": "Mehr lesen",
		"showless": "Weniger anzeigen",
		"showmore": "Mehr sehen",
		"morealbums": "Mehr Alben auf Qobuz",
		"moreplaylisttrack": "Hören Sie die gesamte Playlist auf Qobuz",
		"readfocus": "Diesen Panorama-Artikel auf Qobuz lesen",
		"seeSubscribes": "Die Streaming-Abonnements sehen",
		"cookies": "Cookie-Einstellungen"
	},
	"infos": {
		"trackCount": "{count} Tracks",
		"label": "Label: {label}",
		"composer": "Komponist: {composer}",
		"producers": "Produktion",
		"mixers": "Mixing/Mastering",
		"diskCount": "{count} Alben",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Privat",
			"public": "Öffentlich"
		},
		"hires": "Hohe Qualität",
		"available": "Verfügbar in"
	},
	"share": {
		"twitter": {
			"track": "Hören Sie {title} von {artist} auf Qobuz",
			"album": "Hören Sie {title} von {artist} auf Qobuz",
			"artist": "Hören Sie {artist} auf Qobuz",
			"playlist": "Hören Sie {playlist} von {owner} auf Qobuz",
			"story": "Lesen Sie diesen Artikel auf Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} von {artist} finden Sie auf Qobuz !",
				"body": "Höre dir {title} von {artist} mit Qobuz in bester Soundqualität an: {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} von {artist} finden Sie auf Qobuz !",
				"body": "Höre dir {title} von {artist} mit Qobuz in bester Soundqualität an: {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} ist bei Qobuz !",
				"body": "Höre dir {artist} mit Qobuz in bester Soundqualität an: {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} von {owner} finden Sie auf Qobuz!",
				"body": "Höre dir {playlist} von {owner} mit Qobuz in bester Soundqualität an: {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "\nZum Lesen {url}\n\nQobuz ist der führende Anbieter für Musikstreaming und -downloads in hoher Klangqualität.\nWeitere Informationen und Anmeldung unter Qobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "Zum Kopieren klicken",
			"copy": "Kopieren",
			"copied": "Kopiert",
			"link": "Kopieren Sie den folgenden Link, um ihn zu teilen"
		}
	},
	"tracklist": {
		"title": {
			"track": "Track",
			"album": "Albumtitel",
			"artist": "Die besten Tracks",
			"artist_albums": "Alben",
			"playlist": "Tracks der Playlist"
		},
		"header": {
			"number": "#",
			"name": "Titel",
			"album": "Album",
			"artist": "Künstler",
			"time": "Laufzeit",
			"label": "Label"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Kein Track verfügbar"
	},
	"story": {
		"404": {
			"title": "Der von Ihnen angeforderte Artikel ist in Ihrer geografischen Zone nicht vorhanden.",
			"description": "Zurück zur Startseite des Qobuz-Magazins"
		},
		"from": "Von {author}",
		"albumOverlay": " - {releaseYear} - {genre}",
		"joinQobuz": "Melden Sie sich bei Qobuz an, um den ganzen Artikel zu lesen...",
		"signUp": "Kostenlos testen"
	},
	"playlist": {
		"from": "Von {author}"
	},
	"album": {
		"by": "von",
		"publishedBy": "erschienen bei"
	},
	"notifications": {
		"nostream": "Die Rechteinhaber haben diesen Track nicht zum Streaming freigegeben"
	},
	"aside": {
		"title": "Informationen"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/de.json
// module id = 563
// module chunks = 0